const utils = {
    isNull(value: any):Boolean {
        return value === null || value === undefined;
    },

    isNotNull(value: any):Boolean {
        return !this.isNull(value)
    }
};

export default utils;
